<template>
    <v-container fluid grid-list-xl class="pt-0">
        <v-layout align-center wrap>
            <v-flex pt-0>
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>
                            <v-icon>fa fa-eye</v-icon>
                            Detalles del Activo
                        </v-toolbar-title>
                        <v-divider class="mx-2" inset vertical></v-divider>

                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                            <v-btn icon @click="printActivo">
                                <v-icon>fa-print</v-icon>
                            </v-btn>
                            <v-btn icon @click="cancelForm()">
                                <v-icon>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-container fluid grid-list-xl class="px-1 py-1">
                            <v-layout align-center wrap>
                                <v-flex xs12 sm2 pr-0 pl-4 style="max-width: 174px">
                                    <v-avatar size="150">
                                        <v-img
                                            :src="detailsItem.imagen ? detailsItem.imagen : require('@/images/avatar.png')"
                                        ></v-img>
                                    </v-avatar>
                                </v-flex>

                                <v-flex xs12 sm4 pa-0>
                                    <h4 class="blue--text text-xs-center mb-2">Código: {{ detailsItem.codigo }}</h4>
                                    <div class="text-xs-center mb-2">
                                        Marca: {{ detailsItem.marca ? detailsItem.marca : "-" }}
                                    </div>
                                    <div class="text-xs-center mb-2">
                                        Modelo: {{ detailsItem.modelo ? detailsItem.modelo : "-" }}
                                    </div>
                                    <div class="text-xs-center mb-2">
                                        Serie: {{ detailsItem.serie ? detailsItem.serie : "-" }}
                                    </div>

                                    <div class="text-xs-center pt-1">
                                        <v-btn
                                            flat
                                            small
                                            round
                                            outline
                                            color="orange"
                                            :disabled="loading"
                                            @click="openForm(detailsItem)"
                                        >
                                            Editar
                                        </v-btn>
                                        <v-btn
                                            flat
                                            small
                                            round
                                            outline
                                            color="red"
                                            :disabled="loading"
                                            @click="deleteItem(detailsItem)"
                                        >
                                            {{ deleteActivoConfirm ? "Confirmar" : "Eliminar" }}
                                        </v-btn>
                                    </div>
                                </v-flex>
                                <v-flex sm6>
                                    <v-container fluid grid-list-xl class="px-1 py-0">
                                        <v-layout align-center wrap>
                                            <v-divider inset vertical></v-divider>
                                            <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Campus:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.campus ? detailsItem.campus.nombre : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Departamento:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.departamento ? detailsItem.departamento.nombre : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Sección:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.seccion ? detailsItem.seccion.nombre : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Edificio:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.edificio ? detailsItem.edificio.nombre : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Área:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.area ? detailsItem.area.nombre : "-"
                                                }}</v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-flex sm12>
                                    <v-divider></v-divider>
                                    <v-container fluid grid-list-xl class="px-1 py-1">
                                        <v-layout align-center wrap>
                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-0" wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Descripción:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.descripcion ? detailsItem.descripcion : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-0" wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Costo:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.costo ? detailsItem.costo : "-"
                                                            }}</v-flex>

                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Fecha ingreso:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.fecha_ingreso
                                                                    ? detailsItem.fecha_ingreso
                                                                    : "-"
                                                            }}</v-flex>

                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Fecha baja:</v-flex
                                                            >

                                                            <v-flex sm5>{{
                                                                detailsItem.fecha_baja ? detailsItem.fecha_baja : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left class="px-1 pb-3" wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Grupo:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.grupo ? detailsItem.grupo.nombre : "-"
                                                            }}</v-flex>

                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Tipo:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.tipo ? detailsItem.tipo.nombre : "-"
                                                            }}</v-flex>

                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Estado:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.estado ? detailsItem.estadoa.nombre : "-"
                                                            }}</v-flex>

                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Categoría:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.categoria
                                                                    ? detailsItem.categoria.nombre
                                                                    : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-flex sm12>
                                    <v-divider></v-divider>
                                    <v-container fluid grid-list-xl class="px-1 py-2">
                                        <v-layout align-center wrap>
                                            <v-flex tag="strong" sm12 text-xs-center mr-2 pb-1>Responsables:</v-flex>
                                            <v-flex sm5 pt-0></v-flex>
                                            <v-flex sm7 pt-0 pl-4>
                                                <template v-if="detailsItem.responsables.length">
                                                    <li :key="empleado.id" v-for="empleado in detailsItem.responsables">
                                                        {{
                                                            empleado.nombre +
                                                                " " +
                                                                empleado.apellido_paterno +
                                                                " " +
                                                                empleado.apellido_materno
                                                        }}
                                                    </li>
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <activo-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm">
        </activo-form>

        <print-activo-template v-show="false" :activo-object="detailsItem" id="printActivo"></print-activo-template>
    </v-container>
</template>

<script>
const PrintActivoTemplate = () => import("@/views/finanzas/print-activo-template")
const ActivoForm = () => import("@/components/finanzas/activo/activo-form/activo-form")
import { mapGetters } from "vuex"
export default {
    name: "ActivoDetails",
    components: { PrintActivoTemplate, ActivoForm },
    props: {
        item: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,

            title: "",
            showForm: false,
            editItem: null,

            deleteActivoConfirm: false
        }
    },
    methods: {
        cancelForm() {
            this.$emit("detailsCanceled")
        },

        openForm(item) {
            this.title = "Modificar activo"
            this.editItem = item
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(item) {
            if (this.deleteActivoConfirm) {
                this.loading = true
                this.$store.dispatch("DELETE_ACTIVO", item).then(() => {
                    this.loading = false
                    this.$emit("detailsCanceled")
                    this.deleteActivoConfirm = false
                })
            } else {
                this.deleteActivoConfirm = true
            }
        },

        printActivo() {
            this.$htmlToPaper("printActivo")
        }
    },

    computed: {
        ...mapGetters(["ACTIVOS"]),

        detailsItem() {
            return this.ACTIVOS.filter(el => el.id === this.item.id)[0]
        }
    }
}
</script>

<style scoped></style>
